import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';
import { useAuth } from '../contexts/AuthContext';

export const useMaintenanceMode = () => {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
  const [hasAccess, setHasAccess] = useState(false);
  const { currentUser } = useAuth();

  useEffect(() => {
    // Verificar se usuário está autenticado (tem acesso durante manutenção)
    if (currentUser) {
      setHasAccess(true);
    } else {
      setHasAccess(false);
    }

    // Verificar modo manutenção no Firebase
    const maintenanceRef = doc(db, 'system', 'maintenance');
    
    const unsubscribe = onSnapshot(maintenanceRef, (doc) => {
      if (doc.exists()) {
        const data = doc.data();
        const maintenanceEnabled = data.enabled === true;
        setIsMaintenanceMode(maintenanceEnabled);
      } else {
        setIsMaintenanceMode(false);
      }
    }, (error) => {
      console.error('Erro ao verificar modo manutenção:', error);
      setIsMaintenanceMode(false);
    });

    return () => unsubscribe();
  }, [currentUser]);

  const shouldRedirectToMaintenance = () => {
    return isMaintenanceMode && !hasAccess;
  };

  return {
    isMaintenanceMode,
    hasAccess,
    shouldRedirectToMaintenance
  };
};
